export default __webpack_public_path__ + "static/media/milestone 2400.97b6d95c.svg";